<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>客户订单信息</span>
        <el-button-group style="float: right; padding: 3px 0">
          <!-- <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
          <el-button type="danger" size="small" @click="handleMemberDel">删除</el-button> -->
        </el-button-group>
      </div>

      <div :v-model="data">
        <custom-order-item
          v-for="(item, index) in data"
          v-show="index < 1 || showMore"
          :key="index + '_' + item.id"
          :data="item" 
          :show-edit="item.showEdit" 
          :index="index"
          @change-show="handleMemberShow" 
          @change-save="handleMemberSave"
          @change-update="handleMemberUpdateSave"
        ></custom-order-item>
        <el-button v-if="data.length > 1" style="width: 100%;" type="text" @click="showMore = !showMore"> {{ showMore ? '收起' : `显示剩余 ${ data.length - 1 } 条` }}</el-button>
      </div>
      
    </el-card>
    <!-- <el-dialog 
      title="删除保单"
      :visible.sync="showDel"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <label> 选择你要删除的保单 </label>
      <el-table
        ref="multipleTable"
        :data="data"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="全选">
          <template slot-scope="scope">{{ scope.row.role }}-{{ scope.row.data ? scope.row.data.name : ''}}</template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="$emit('change-show', false)">取 消</el-button>
        <el-button type="primary" @click="handleSaveDel"> 确 定 </el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import CustomOrderItem from './CustomOrderItem.vue'

  export default {
    name: 'CustomOrderInfo',
    components: { CustomOrderItem  },
    props: {
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      showDel: {
        type: Boolean,
        default: false
      },
      submitSuccess: {
        type: Boolean,
        default: false
      }
    },
    filters: {
    },
    data () {
      return {
        delList: [],
        showMore: false
      }
    },
    computed: {

    },
    created() {
    },
    methods: {
      handleAdd() {            
        const item = this.data.find(k => !k.id) 
        if (!item) {
          let ff = [{showEdit: true}]
          this.data.forEach(i => ff.push(i))
          this.$emit('change-add', ff)
        }
      },
      handleMemberShow(value, index) {
        if (this.data.length > index) {
          this.$set(this.data[index], 'showEdit', value)
        }
      },
      handleMemberSave(role, value, index) {
        this.$emit('change-save', role, value)
        if (this.data.length > index && this.submitSuccess) {
          this.$set(this.data[index], 'showEdit', false)
        }
      },
      handleMemberDel() {
        this.delList = []
        this.$emit('change-show', true)
      },
      handleSaveDel() {
        this.$emit('change-del', this.delList)
      },
      handleMemberUpdateSave(value, index) {
        this.$emit('change-update', value)

        if (this.data.length > index && this.submitSuccess) {
          this.$set(this.data[index], 'showEdit', false)
        }
      },
      handleSelectionChange(val) {
        this.delList = val
      }
    }
  }
</script>
<style scoped>
</style>